import { Component } from "react";

class PublicPage extends Component {
  render() {
    return <h3>Public</h3>;
  }
}

export default PublicPage;
